import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueCookies from 'vue-cookies'

Vue.use(VueI18n)
Vue.use(VueCookies)

const messages = {
  en: {
    en: 'English',
    de: 'German'
  },
  de: {
    en: 'Englisch',
    de: 'Deutsch'
  }
}

const numberFormats = {
  en: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol'
    }
  },
  de: {
    currency: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol'
    }
  }
}

const locale =
  Vue.$cookies.get('i18n') || navigator.language.split('-')[0].toLowerCase()

const i18n = new VueI18n({
  locale: locale || 'en',
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages,
  numberFormats
})

export default i18n
